module.exports = __webpack_public_path__ + "static/ERDAL_BULGARISTAN-aba1b4a7378f9fb5b3207223732457f4.jpeg";